import { withAITracking } from "@microsoft/applicationinsights-react-js";
import React from "react";
import { Container } from "react-bootstrap";
import Row from "react-bootstrap/esm/Row";
import { reactPlugin } from "../../../utilities/AppInsights";
import "./CreateLoanPage.css"
import { AppState } from "redux/store/store";
import { toggleAPIRequestSuccess, toggleLoading } from "redux/actions/system/actions";
import Dealer from "models/dealerPurchase/dealer";
import { ConnectedProps, connect } from "react-redux";
import dealerService from "accessors/dealerService";
import LoadingSpinner from "shared/components/spinner/LoadingSpinner";
import LoanApplication from "models/loan/loanApplication";
import loanApplicationService from "accessors/loanApplicationService";
import ApplicantForm from "../../../components/loan/applicationForm/ApplicationForm";


const mapState = (state: AppState, route: any) => {
  const { system } = state;
  const { isLoading, apiRequestSuccess, loggedInAccount } = system;
  return {
    isLoading,
    apiRequestSuccess,
    route,
    loggedInAccount
  };
};

const mapDispatch = {
  toggleLoading: (isLoading: boolean) => toggleLoading(isLoading),
  toggleAPIRequestSuccess: (apiRequestSuccess: boolean) => toggleAPIRequestSuccess(apiRequestSuccess)
}

const connector = connect(mapState, mapDispatch);
type PropsFromRedux = ConnectedProps<typeof connector>;
type Props = PropsFromRedux;

interface CreateLoanPageState {
  dealers: Dealer[];
  anonymousDraftTokens: string[];
}

class CreateAccountPage extends React.Component<Props, CreateLoanPageState> {
  constructor(props: any) {
    super(props);

    this.state = {
      dealers: [],
      anonymousDraftTokens: []
    }
  }

  componentDidMount() {
    this.loadDealers();
    const params = new URLSearchParams(this.props.route?.location?.search ?? window.location.search);
    const claimTokensParam = params.get('claimTokens');
    if (claimTokensParam) {
      const anonymousDraftTokens = JSON.parse(decodeURIComponent(claimTokensParam)) as string[];
      this.setState({ anonymousDraftTokens });
      const url = new URL(window.location.href);
      url.searchParams.delete('claimTokens');
      window.history.replaceState({}, '', url.toString());
    }
  }

  loadDealers() {
    this.props.toggleLoading(true);
    dealerService.GetDealersPublic()
      .then(dealers => {
        this.props.toggleLoading(false);
        this.setState({ dealers: dealers })
      })
  }

  async submitLoanApplication(loanApplication: LoanApplication): Promise<boolean> {
    this.props.toggleLoading(true);

    const loanId = await loanApplicationService.SubmitLoanApplication(loanApplication);
    this.props.toggleLoading(false);

    if (loanId > 0) {
      this.props.route.history.push(`/loan/${loanId}`);
    }
    return loanId > 0;
  }

  render() {
    return (
      <div className="container">
        <Container className="align-items-center">
          <Row className="justify-content-md-center">
            <ApplicantForm
              dealers={this.state.dealers}
              userLoggedIn={true}
              customerAccountInfo={this.props.loggedInAccount}
              toggleLoading={this.props.toggleLoading}
              submitCallback={this.submitLoanApplication.bind(this)}
              anonymousDraftTokens={this.state.anonymousDraftTokens}
            ></ApplicantForm>
          </Row>
        </Container>
        {this.props.isLoading &&
          <LoadingSpinner
            variant={'dark'}
            animation={'border'}
          />
        }
      </div>
    );
  }
}

export default withAITracking(reactPlugin, connector(CreateAccountPage));
